// 页面配置
export default {
  preclass: 'Download APP "Think Academy"',
  preclassTips2: ' for joining Competitions & Courses.',
  orderResult: {
    teacherPrefix: 'Your ',
    copy: 'Copy',
    contactTip: '  If you have any questions, please contact your teacher.',
    successTilte: 'Registration Successful',
    successContent: 'Think Academy will send you an email regarding APP DOWNLOAD and relevant materials. If you have any questions, contact us via below:',
    enquiriesText: 'For enquiries on your orders, please contact us via ',
    goodsResult: {
      successNotice: 'Purchase successful.',
      failNotice: 'Purchase failed.',
      failDesc: 'View more services provided by Think Academy.',
      successButton: 'View Order',
      failButton: 'View Our Courses',
    },
  },
  common: {
    orderStatusDesc: {
      refunding: [
        'Your refund request has been approved.',
        'Your refunds will be returned to your payment account ',
        'within 7 business days.',
      ],
      refunded: 'Your refund request will be processed within 24 hours.',
    },
    refundInfo: {
      paymentLabel: 'Payment tuition',
      dialogTitle: 'The purchased recorded course is expired',
      dialogMessage: 'Expired Date: {date} Refund is not applicable. Please contact the support team, should you had any quesiton:',
    },
  },
  learningMaterials: 'Hard Copy Course Workbook (Optional)',
  priceInfo: {
    tax: 'VAT',
  },
  orderCreate: {
    showConfirmCheckbox: true,
    // eslint-disable-next-line
    confirmCheckboxText: 'I confirmed that I have read, understood and agreed to the <a class="link-text" href="/terms-of-use" target="_blank">Terms of Use</a>. ',
  },
  orderDetail: {
    nonRefundForOvertime: {
      notice: 'Sorry, we don\'t process refunds beyond 30 days old. If you have any questions, please contact us via Malaysia@tal.com',
    },
  },
  orderRefund: {
    instruction: 'The total refund amount is inclusive of VAT',
    refundAuth: {
      contactTip: {
        mobile: 'If you need to change your phone number, please contact the customer service at (<a class="contact-email-link" :href="mailto:Malaysia@tal.com">Malaysia@tal.com</a>)',
        email: 'If you need to change your email address, please contact the customer service at (<a class="contact-email-link" :href="mailto:Malaysia@tal.com">Malaysia@tal.com</a>)',
      },
    },
  },
};
